/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PracticeConventionAggregateState {
	NotApplicable = "NotApplicable",
	NotGenerated = "NotGenerated",
	PendingSignatures = "PendingSignatures",
	Finalized = "Finalized",
}

export function PracticeConventionAggregateStateFromJSON(
	json: any
): PracticeConventionAggregateState {
	return PracticeConventionAggregateStateFromJSONTyped(json, false);
}

export function PracticeConventionAggregateStateFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeConventionAggregateState {
	return json as PracticeConventionAggregateState;
}

export function PracticeConventionAggregateStateToJSON(
	value?: PracticeConventionAggregateState | null
): any {
	return value as any;
}
